import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, model, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { JobCardDetails, ManageComplaintService } from '../../../../core/services/manage-complaints.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SimpleCodeValue } from '../../../../core/models/code-value.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

export interface DialogData {
  jobCardData: JobCardDetails[];
  event: JobCardDetails;
  title: string;
  departments: SimpleCodeValue[];
}

@Component({
  selector: 'app-issue-job-card-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    CommonModule,
    FormsModule,
    MatInputModule
  ],
  templateUrl: './issue-job-card-dialog.component.html',
  styleUrl: './issue-job-card-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssueJobCardDialogComponent implements OnInit, AfterViewInit {

  readonly dialogRef = inject(MatDialogRef<IssueJobCardDialogComponent>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  readonly title = model(this.data.title);
  readonly jobCardData = model(this.data.jobCardData);
  readonly event = model(this.data.jobCardData); // Only valid at class member level

  departments: SimpleCodeValue[] = [];
  employees: SimpleCodeValue[] = [];
  employeeId!: number;
  comments!: string;
  departmentId!: number;
  assignedEmployeeId?: number;

  constructor(
    private cdr: ChangeDetectorRef,
    private manageComplaintService: ManageComplaintService,
  ) {
  }

  ngOnInit(): void {
    this.departmentId = this.data.jobCardData[0].compAssignedDeptId;
    if(this.data.jobCardData[0].complaintStatus === 'ASSIGNED' || this.data.jobCardData[0].complaintStatus === 'REOPEN') {
      this.getEmployeesForDepartment(this.data.jobCardData[0].compAssignedDeptId.toString());
    }

    // Store assigned employee ID if status is JOBCARDISSUED
    if (this.data.jobCardData[0].complaintStatus === 'JOBCARDISSUED' && this.data.jobCardData[0].taskAssEmpId) {
      this.assignedEmployeeId = this.data.jobCardData[0].taskAssEmpId;

      // Get departments of current compAssignedDeptId's parent department
      this.manageComplaintService.getDepartmentsWithSameParentDepartment(this.data.jobCardData[0].compAssignedDeptId.toString()).subscribe({
        next: (response) => {
          this.departments = response;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('GET error:', error);
        },
      });
    }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  onNoClick(): void {
    this.dialogRef.close({ approved: false, jobCardData: null, employeeId: null, departmentId: null });
  }

  onApproved() {
    this.dialogRef.close(
      { 
        approved: true, 
        jobCardData: this.data.jobCardData, 
        employeeId: this.employeeId,
        departmentId: this.departmentId,
        comments: this.comments
      }
    );
  }

  getEmployeesForDepartment(departmentId: string) {
    this.manageComplaintService.getEmployeesAssignableForDepartment(departmentId).subscribe({
      next: (response) => {
        this.employees = response;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('POST error:', error);
      },
    });
  }

  // Used in template to disable assigned employee option
  isEmployeeDisabled(employee: SimpleCodeValue): boolean {
    console.log('Checking if employee is disabled:', employee);
    console.log('Assigned Employee ID:', this.assignedEmployeeId);
    console.log('Job Card Data:', this.data.jobCardData[0]);
    return (
      this.data.jobCardData[0].complaintStatus === 'JOBCARDISSUED' &&
      this.assignedEmployeeId === Number(employee.code)
    );
  }

}
